import React from "react";
import withStyles from "components/with-styles";
import Icon from "components/icon";
import styles from "./styles/profile-photo.css.js";

const ProfilePhoto = ({ classes }) => (
  <div className={classes.profile}>
    <Icon name="account-circle" />
  </div>
);

export default withStyles(styles)(ProfilePhoto);
